export default "__VITE_ASSET__cahU22VX__"